import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { HeaderWrapper, Headline, ViewAll, ViewAllTxt, ChevronRight } from './SliderHeader.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { UniverseComponent } from 'src/domains/common/universes';

interface SliderHeaderPropsType {
    title: string | JSX.Element;
    withoutViewAll?: boolean;
    onViewAllClick?: () => void;
}

export const SliderHeader = observer('SliderHeader', (props: SliderHeaderPropsType): JSX.Element => {
    const { title, onViewAllClick, withoutViewAll } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { casinoVariant } = configState.componentVariants;
    return (
        <HeaderWrapper data-test='slider-header'>
            <Headline>{title}</Headline>

            {withoutViewAll === true ? null : (
                <ViewAll
                    onClick={onViewAllClick}
                    data-test='view-all-button'
                >
                    <ViewAllTxt>
                        <I18n
                            langKey='casino.home.slider.header.view-all'
                            defaultText='View All'
                        />
                    </ViewAllTxt>
                    {casinoVariant === DefaultComponentVariantType.SECONDARY ? (
                        <UniverseComponent>
                            {(universeVersion): React.ReactElement => <universeVersion.viewAllIcon />}
                        </UniverseComponent>
                    ) : (
                        <ChevronRight
                            position='right'
                            key='view-all'
                        />
                    )}
                </ViewAll>
            )}
        </HeaderWrapper>
    );
});
